import { gsap } from "gsap";

document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('.btn__drawer');
  const drawer = document.querySelector('.mobile-drawer');
  const icon = menuBtn?.querySelector('img');

  if (!menuBtn || !drawer) {
    console.warn('Mobile drawer elements not found');
    return;
  }

  // Ensure drawer starts hidden
  gsap.set(drawer, { x: '100%' });

  menuBtn.addEventListener('click', (e) => {
    e.preventDefault();

    const open = menuBtn.getAttribute('aria-expanded') === 'true';
    const newState = !open;

    menuBtn.setAttribute('aria-expanded', String(newState));

    //
    // 🔥 Add/remove active visual class
    //
    if (newState) {
      menuBtn.classList.add('is-active');
    } else {
      menuBtn.classList.remove('is-active');
    }

    // Animate drawer
    gsap.to(drawer, {
      x: newState ? '0%' : '100%',
      duration: 0.4,
      ease: newState ? 'power2.out' : 'power2.in'
    });

    // Animate icon rotation
    if (icon) {
      gsap.to(icon, {
        rotation: newState ? -45 : 0,
        duration: 0.3,
        ease: 'power2.inOut'
      });
    }
  });
});
